/** @format */

import { Link } from 'gatsby-plugin-intl';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  aspect-ratio: 16/9;
`;

export const CardLink = styled(Link)`
  z-index: 1;
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
  text-decoration: none;
  color: inherit;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  cursor: pointer;
  aspect-ratio: 16/9;
`;

export const GalleryIcons = styled.div`
  z-index: 2;
  display: flex;
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  gap: 0.25rem;
`;

export const DefaultIcon = styled.button`
  display: flex;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  border: 0;
  border-radius: 0.5rem;
  opacity: 0.87;
  background: var(--white, #fff);
  cursor: pointer;

  span {
    display: flex;
    width: 1.25rem;
    height: 1.25rem;
    flex-direction: column;
    justify-content: center;

    color: var(--gray-700, #344054);
    text-align: center;
    font-family: ${({ theme }) => theme.font.body};
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
  }

  &:hover {
    opacity: 1;
  }

  box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1), 0px 1px 2px 0px rgba(16, 24, 40, 0.06);
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  min-height: inherit;
  display: block;
  aspect-ratio: 16/9;
`;

export const CardTagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: absolute;
  top: 1rem;
  left: 1rem;
  gap: 0.25rem;
  z-index: 2;
`;

export const CardTag = styled.div`
  display: flex;
  width: fit-content;
  padding: 0.25rem 0.75rem;
  border-radius: 0.5rem;
  background-color: white;
  box-shadow: 0 0.0625rem 0.125rem 0 #1018280f;
  font-family: ${({ theme }) => theme.font.body};
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
`;
